<template lang="pug">
v-container
  div.text-lg.font-medium.basic700--text Booking confirmation
  v-row(no-gutters)
    v-col(cols="12" sm="6")
      v-card.round-xl.pa-4.mt-4(outlined)
        v-row(no-gutters align="center")
          v-col
            div.text-md.font-semibold.neutral700--text Email
            div.text-md.neutral700--text Send booking confirmation to the patient via email
          v-col.shrink
            yc-checkbox(v-model="bookingConfirmationEmail")

  div.d-flex.mt-5
    v-spacer
    v-btn.button-md(color="neutral700" dark depressed :loading="isLoading" @click="saveData") {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      isLoading: false,
      bookingConfirmationEmail: false
    }
  },
  computed: {
    ...mapGetters({ 
      company: 'getCompany',
      clinic: 'clinic/getClinic'
    }),
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      this.bookingConfirmationEmail = this.clinic.booking_confirmation_email
    },
    saveData () {
      this.isLoading = true
      const data = {
        booking_confirmation_email: this.bookingConfirmationEmail
      }
      this.$axios.patch(`/clinics/${this.company.slug}`, data)
        .then(() => {
          const clinic = { ...this.clinic, booking_confirmation_email: this.bookingConfirmationEmail }
          this.$store.commit('clinic/setClinic', clinic)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }

}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>